export type BikeType = 'road' | 'gravel' | 'trekking' | 'mountain' | 'city' | 'triathlon';
export type RidingStyle = 'comfort' | 'balanced' | 'performance';

export type RidingExperience = 'beginner' | 'intermediate' | 'experienced';
export type Flexibility = 'good' | 'average' | 'limited';
export type PainPoint =
  | 'knee_front'
  | 'knee_back'
  | 'knee_both'
  | 'lower_back'
  | 'neck_shoulder'
  | 'hand_wrist'
  | 'saddle'
  | 'none';

export const RIDING_EXPERIENCE_LABELS: Record<RidingExperience, string> = {
  beginner:     'Beginner (< 1 year)',
  intermediate: 'Intermediate (1–3 years)',
  experienced:  'Experienced (3+ years)',
};

export const FLEXIBILITY_LABELS: Record<Flexibility, string> = {
  good:    'Good',
  average: 'Average',
  limited: 'Limited',
};

export const PAIN_POINT_LABELS: Partial<Record<PainPoint, string>> = {
  lower_back:    'Lower back pain',
  neck_shoulder: 'Neck or shoulder pain',
  hand_wrist:    'Hand or wrist numbness',
  saddle:        'Saddle discomfort',
  none:          'None — I\'m pain-free',
};

export interface BikeOption {
  label: string;
  styles: RidingStyle[];
  default: RidingStyle;
}

export const BIKE_OPTIONS: Record<BikeType, BikeOption> = {
  road:      { label: 'Road bike',              styles: ['comfort', 'balanced', 'performance'], default: 'balanced' },
  gravel:    { label: 'Gravel bike',            styles: ['comfort', 'balanced', 'performance'], default: 'balanced' },
  trekking:  { label: 'Trekking / hybrid bike', styles: ['comfort', 'balanced', 'performance'], default: 'balanced' },
  mountain:  { label: 'Mountain bike',          styles: ['comfort', 'balanced', 'performance'], default: 'balanced' },
  city:      { label: 'City / commuter bike',   styles: ['comfort'],                            default: 'comfort'  },
  triathlon: { label: 'Triathlon / TT bike',    styles: ['balanced', 'performance'],            default: 'balanced' },
};

export const BIKE_TYPE_ORDER: BikeType[] = ['road', 'gravel', 'trekking', 'mountain', 'city', 'triathlon'];

export const RIDING_STYLE_LABELS: Record<RidingStyle, string> = {
  comfort:     'Comfort',
  balanced:    'Balanced',
  performance: 'Performance',
};
